import React, { useMemo } from "react";
import { setUser } from "@jsq/observability";
import { toDbId } from "common/helpers/globalId";
import { useGetCurrentStaffUserQuery } from "common/types/gqlSchemaTypes";
import { UserContext } from "../UserContext";

export const UserProvider: React.FC = ({ children }) => {
  const { data } = useGetCurrentStaffUserQuery();
  const user = useMemo(() => {
    const user = data?.currentUser;
    if (user?.id) {
      setUser({ id: toDbId(user.id).toString() });
    }
    return { user };
  }, [data?.currentUser]);

  return <UserContext value={user}>{children}</UserContext>;
};
